'use strict';

module.exports = [
	'<script type="text/javascript">',
	'  function changeLanguage(lang) {',
	'    document.dispatchEvent(new CustomEvent(\'universalnav:call\', { detail: { widget: \'Header\', method: \'clearStorage\' } }));',
	'    document.cookie = \'locale-language=\' + lang + \'; path=/\';',
	'    window.location.reload();',
	'  }',
	'</script>'
].join('\n');




//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/functions/language-function.tpl.js
// module id = 31
// module chunks = 0